const DISABLED_OPACITY = 0.4;

export default DISABLED_OPACITY;
